module.exports = __webpack_public_path__ + "src/assets/img/page8/3d87e6330e22c6b7141507eaad57d2b6.jpg";